export var GET_STATS = '[Stats] Get Stats';
export var GET_STATS_SUCCESS = '[Stats] Get Stats Success';
export var GET_STATS_ERROR = '[Stats] Get Stats Error';
var GetStats = /** @class */ (function () {
    function GetStats(payload) {
        this.payload = payload;
        this.type = GET_STATS;
    }
    return GetStats;
}());
export { GetStats };
var GetStatsSuccess = /** @class */ (function () {
    function GetStatsSuccess(payload) {
        this.payload = payload;
        this.type = GET_STATS_SUCCESS;
    }
    return GetStatsSuccess;
}());
export { GetStatsSuccess };
var GetStatsError = /** @class */ (function () {
    function GetStatsError(payload) {
        this.payload = payload;
        this.type = GET_STATS_ERROR;
    }
    return GetStatsError;
}());
export { GetStatsError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/actions/stats.action.ts.pre-build-optimizer.js